function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="pf-footer" style={{ position: 'relative', zIndex: 1 }}>
      <span className="footer-copy">
        © {year} Joshua Bautista. Crafted with care.
      </span>
      <a href="#hero" className="footer-back">
        Back to top
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M6 10V2M2 6l4-4 4 4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </a>
    </footer>
  );
}

export default Footer;
